import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';

const stripePromise = loadStripe(
  process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY || '',
);

export const StripeElements: React.FC<{
  children: React.ReactElement | React.ReactElement[];
  clientSecret: string;
}> = ({ children, clientSecret }) => {
  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance: {
          theme: 'night',
          variables: {
            colorPrimary: '#fff',
            colorBackground: '#ffffff1a',
            colorText: '#fff',
            colorTextPlaceholder: '#ffffffb3',
            colorDanger: '#FF4500',
            fontFamily: 'system-ui, sans-serif',
            spacingUnit: '4px',
            borderRadius: '6px',
            focusBoxShadow: 'none',
            focusOutline: '#ffffff1a',
          },
          rules: {
            '.Input': {
              backgroundColor: '#ffffff1a',
              borderColor: 'transparent',
              boxShadow: 'none',
              color: '#fff',
              padding: '16px 12px',
            },
            '.Input:hover': {
              backgroundColor: '#ffffff33',
            },
            '.Input:focus': {
              borderColor: '#ffffff1a',
            },
            '.Input--invalid:focus': {
              borderColor: '#FF4500',
            },
            '.Error': {
              fontSize: '0.75rem',
            },
          },
        },
      }}
    >
      {children}
    </Elements>
  );
};
